import styled from 'styled-components'
import Div from 'components/Div'

const DivButton = styled(Div).attrs(() => ({
  role: 'button'
}))`
  cursor: pointer;
`

export default DivButton
